import { render, staticRenderFns } from "./TagTaskForm.vue?vue&type=template&id=9473a0d2&scoped=true&"
import script from "./TagTaskForm.vue?vue&type=script&lang=js&"
export * from "./TagTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9473a0d2",
  null
  
)

export default component.exports